import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { invokeGetService, invokePostService, setDashboardRefresh, setReRender, toggleRightDrawer } from "../../../store/global/actions";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import { getDetailsFromUrl, getFirstOrderEvents } from '../../../services/blueprint'
import { getViews } from "../../../store/views/selectors";
import { findSelectedSchema } from "../../../services/builder/util";
import { editView } from "../../../store/views/actions";
import { getRightDrawerStatus } from '../../../store/global/selectors';
import { useHistory } from 'react-router-dom';
import { controlTypes, actionRequiredTypes, tableBtn, mappingTransactionSchema, generateUpdatedMessageFields, sortFieldsByOrder } from '../../../config/fields';
import { findChildren } from '../../../services/entities/simulations.js';
import { findTriggerEvent, formatConstraintToDropdownValues } from '../../../utils/commonUtils.js';
import { Box, Grid } from '@material-ui/core';
import JsonTableEditor from '../../atoms/jsonFormEditor/JsonTableEditor.js';
import UpdateCancel from '../../atoms/buttons/UpdateCancel.js';
import FieldExtensionTable from '../../atoms/FieldExtensionTable/index.js';
import { clearFormErrors, findHelperText, injectHelper, injectInlineHelperText, showJsonEditorCustomValidationErrors, updateViewSchema } from '../../../utils/DashboardBuilder.js';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader.js';
import { logError } from '../../../utils/logger.js';
const shortUUiD = require("short-uuid");

const options = {
    form_name_root: "operations",
    show_errors: "interaction"
}

export default function EventSelector({ onClose, forceCancel, id, onCompletion, noFloatButton, action, selectedSchema, index, updateTableOperations }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const editorWrapper = useRef()

    const selectedView = useSelector(getViews)
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    

    const { slug, blueprintId } = getDetailsFromUrl();
    const eventTriggerRequiredTypes = [...controlTypes, ...tableBtn, 'chat'];
    const editorId = index ? `operation_form_${index}` : "operation_form";

    const [loading, setLoading] = useState(false)
    const [schemaValues, setSchemaValues] = useState({})
    const [isUpdating, setIsUpdating] = useState(false);
    const [allEvents, setAllEvents] = useState([])
    const [clusterlets, setClusterlets] = useState([]);
    const [allFields, setFields] = useState([])
    const [formValues, setFormValues] = useState({})
    const [eventFields, setEventFields] = useState([])
    const [extendedFieldsData, setExtendedFieldsData] = useState([]);
    const [allMessages, setMessages] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [transactionMapping, setTransactionMapping] = useState({});
    const [fieldsHistory, setFieldsHistory] = useState(null)
    const [editorObj, setEditorObj] = useState(null);
    const [getterTransaction, setGetterTransaction] = useState({});

    const selectedWidget = findSelectedSchema({ schemas: selectedView.view_schema, id });
    const hideFieldExtensionsTable = selectedWidget?.type === 'chat'


    useEffect(() => {
        loadClusterlets()
    }, [])

    const loadClusterlets = () => {
        setLoading(true)
        dispatch(invokeGetService('getBlueprintConstructs', []))
            .then((blueprintConstructs) => {
                const filteredTransactins = blueprintConstructs?.data?.transactions ? blueprintConstructs?.data?.transactions?.filter(tr => tr.type == 7) : [];
                setTransactions(filteredTransactins);

                setFields(blueprintConstructs?.data?.fields)
                setMessages(blueprintConstructs?.data?.messages)
                const firstOrderEvents = getFirstOrderEvents(blueprintConstructs?.data?.events, blueprintConstructs?.data?.clusterlets);

                setSchemaValues(mappingSchema(selectedSchema, blueprintConstructs?.data?.transactions, blueprintConstructs?.data?.events, blueprintConstructs?.data?.clusterlets, blueprintConstructs?.data?.fields, firstOrderEvents, blueprintConstructs?.data?.messages));
                setClusterlets(blueprintConstructs?.data?.clusterlets);
                setAllEvents(firstOrderEvents);
                let getterTransactionSchema = mappingTransactionSchema(blueprintConstructs?.data?.transactions, false, [...blueprintConstructs?.data?.clusterlets, ...blueprintConstructs?.data?.clusterlets.filter(c => c.type === 1)], blueprintConstructs?.data?.events, blueprintConstructs?.data?.clusterlets.filter(c => c.type === 1), true, false, "Getter Transaction");
                setGetterTransaction(getterTransactionSchema)
                let transactionMappingSchema1 = mappingTransactionSchema(blueprintConstructs?.data?.transactions, false, [...blueprintConstructs?.data?.clusterlets, ...blueprintConstructs?.data?.clusterlets.filter(c => c.type === 1)], blueprintConstructs?.data?.events, blueprintConstructs?.data?.clusterlets.filter(c => c.type === 1), true, false);
                setTransactionMapping(transactionMappingSchema1)
                setLoading(false)
            })
    }


    const mappingSchema = (selectedSection, transactions, events, clusterlets, fields, firstOrderEvents, messages) => {
        let schemaValues = {};
        let selectedItem = {};

        // For table actions
        if (selectedSection !== undefined && selectedSection !== null) {
            schemaValues = { ...selectedSection };

            if (schemaValues.transaction != undefined && schemaValues.extendedfields != undefined) {
                const transactionData = transactions?.find(txn => txn._id === schemaValues.transaction);
                const triggerringEvent = findTriggerEvent({ transaction: transactionData, events, clusterlets });
                let eventMessage = messages?.find(msg => msg._id === triggerringEvent?.message)
                let messageChildren = findChildren(eventMessage, [], fields)
                const updatedMessageFields = generateUpdatedMessageFields(schemaValues.extendedfields, messageChildren?.children)
                setEventFields(updatedMessageFields)
                setFieldsHistory({
                    [schemaValues.transaction]: updatedMessageFields
                })
            }
        }

        // For control widgets
        if (eventTriggerRequiredTypes.includes(selectedWidget?.type)) {
            selectedItem = selectedWidget;
            if (selectedItem?.transaction && selectedItem?.extendedfields) {

                const transactionData = transactions?.find(txn => txn._id === selectedWidget?.transaction);
                const triggerringEvent = findTriggerEvent({ transaction: transactionData, events, clusterlets });
                let eventMessage = messages?.find(msg => msg._id == triggerringEvent?.message)
                let messageChildren = findChildren(eventMessage, [], fields)

                const updatedMessageFields = generateUpdatedMessageFields(selectedItem?.extendedfields, messageChildren?.children)

                setEventFields(updatedMessageFields)
                setFieldsHistory({
                    [selectedItem.transaction]: updatedMessageFields
                })
            }

        } else if (actionRequiredTypes.includes(selectedWidget?.type) && selectedSchema != undefined) {
            selectedItem = selectedSchema
            schemaValues.name = selectedSection.name !== undefined ? selectedSection.name : '';
            schemaValues.title = selectedSection.title !== undefined ? selectedSection.title : '';
        }
        schemaValues.gettertransaction = selectedItem.gettertransaction !== undefined ? { [selectedItem.gettertransaction]: selectedItem.gettertransaction } : { 'select': 'select' };
        schemaValues.gettertransaction.instance = selectedItem.getterinstance !== undefined ? selectedItem.getterinstance : '';


        schemaValues.transaction = selectedItem.transaction !== undefined ? { [selectedItem.transaction]: selectedItem.transaction } : { 'select': 'select' };
        schemaValues.transaction.instance = selectedItem.instance !== undefined ? selectedItem.instance : '';

        schemaValues.clicktrackertransaction = selectedItem.clicktrackertransaction !== undefined ? { [selectedItem.clicktrackertransaction]: selectedItem.clicktrackertransaction } : { 'select': 'select' };
        schemaValues.clicktrackertransaction.instance = selectedItem.clicktrackinstance !== undefined ? selectedItem.clicktrackinstance : '';

        return schemaValues
    }


    let commonProperties = {
        transaction: {
            title: 'Transaction',
            type: 'string',
            enumSource: [{
                source: [{ title: 'Select', value: 'select' }, ...transactions.map((txn) => { return { 'title': txn.name, 'value': txn._id } })],
                title: '{{item.title}}',
                value: '{{item.value}}'
            }],
            options: {
                layout: 'grid',
                grid_columns: 12
            }
        },
        instance: {
            title: 'Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 12
            },
        },
    };

    if (selectedWidget?.type !== "chat") {
        commonProperties = {
            name: {
                title: 'Name',
                type: 'string',
                required: true,
                options: {
                    layout: 'grid',
                    grid_columns: 12
                },
            },
            title: {
                title: 'Label',
                type: 'string',
                required: true,
                options: {
                    layout: 'grid',
                    grid_columns: 12
                },
            },
            ...commonProperties
        }
    }


    let schema = {
        type: 'object',
        required: [],
        options: {
            layout: 'grid',
            disable_properties: 'false'
        },
        properties: eventTriggerRequiredTypes.includes(selectedWidget?.type) ? { gettertransaction: getterTransaction.transaction, transaction: transactionMapping.transaction } : { name: commonProperties.name, title: commonProperties.title, gettertransaction: getterTransaction.transaction, transaction: transactionMapping.transaction }
    }


    if (selectedWidget?.type === "chat") {
        schema = { ...schema, properties: { transaction: transactionMapping.transaction, clicktrackertransaction: { ...transactionMapping.transaction, title: "Link Tracker Transaction" } } }
    }


    const onChangeJsonEditor = (values, jsonEditor) => {
        setFormValues(values);
        setEditorObj(jsonEditor);
        if (values !== undefined && values?.transaction !== undefined && values?.transaction.select === undefined) {
            const keys = Object.keys(values?.transaction);
            const transactionData = transactions?.find(txn => txn._id === keys[0]);
            const triggerringEvent = findTriggerEvent({ transaction: transactionData, events: allEvents, clusterlets });

            if (fieldsHistory != null && fieldsHistory[transactionData?._id]) {
                setEventFields(fieldsHistory[transactionData?._id])
            } else {
                setEventFields(triggerringEvent ? formatFileds(triggerringEvent._id) : []);
            }
        }
        else {
            setEventFields([])
        }

        console.log("Values-------", {values, selectedWidget})

        switch (selectedWidget.type) {

            case "chat":
                injectHelper(editorId, "operations.transaction", "chat_box_widget", "setter");

                injectHelper(editorId, "operations.clicktrackertransaction", "chat_box_widget", "link_tracker");
                break;

            case "table":
                injectHelper(editorId, "operations.gettertransaction", "table_operation", "getter");

                injectHelper(editorId, "operations.transaction", "table_operation", "setter");
                break;

            case "control-button":
                injectHelper(editorId, "operations.gettertransaction", "button_widget", "getter");

                injectHelper(editorId, "operations.transaction", "button_widget", "setter");
                break;

            case "control-switch":
                injectHelper(editorId, "operations.transaction", "switch_widget", "setter");
                break;

            case "control-slider":
                injectHelper(editorId, "operations.transaction", "slider_widget", "setter");
                break;

            case "control-joystick":
                injectHelper(editorId, "operations.transaction", "joystick_widget", "setter");
                break;

            default:
                break;
        }

    }

    

    const getFormattedMessageFields = (messageFields=[]) => {
        const sortedFields = sortFieldsByOrder(messageFields || [])
        
        function generateNested(fields) {
            return fields?.map(item => {
                let newObj = {
                    id: item._id,
                    name: item.name,
                    type: item.attributes.type,
                    optional: item.attributes?.optional,
                    desc: item.attributes.desc ? item.attributes.desc : '',
                    children: []
                };

                if (item?.attributes?.default && item?.attributes.default !== "") {
                    newObj.default = item.attributes.default;
                }

                if (item?.attributes?.constraint && item?.attributes.constraint !== "") {
                    newObj.constraint = item.attributes.constraint;
                }

                if (item.children) {
                    newObj.children = generateNested(item.children.map(child => ({ ...child })));
                }

                if (newObj.constraint) {
                    newObj.constraint = formatConstraintToDropdownValues(newObj.constraint);
                    newObj.defaultConstraint = newObj.constraint;
                }

                return newObj;
            });
        }

        let eventFields = generateNested(sortedFields);
        return eventFields;
    }

    const formatFileds = (eventId, idRequired) => {
        let selectedEvent = allEvents.find(ev => ev._id === eventId)
        let eventMessage = allMessages.find(msg => msg._id === selectedEvent.message)

        if (selectedEvent === undefined) {
            return []
        }
        let fields = JSON.parse(JSON.stringify(allFields));
        let newData = findChildren(eventMessage, [], fields, allMessages)
        let formattedEventFileds = newData !== undefined ? getFormattedMessageFields(newData.children) : [];

        return formattedEventFileds;

    }



    const onUpdate = () => {
        try {

            clearFormErrors();
            const editorValidationErrors = editorObj.validate();
            const customValidationErrors = customValidation()
            showJsonEditorCustomValidationErrors(customValidationErrors)
            if ([...editorValidationErrors, ...customValidationErrors].length > 0) {
                editorObj.showValidationErrors(editorValidationErrors);
                return;
            }

            const { name, title, transaction, clicktrackertransaction, gettertransaction } = formValues;
            setIsUpdating(true)


            let selectedItem = { ...selectedWidget }
            let transactionObj = {}

            if (transaction !== undefined && transaction.select === undefined) {
                let new_extended_fields = extendedFieldsData?.length > 0 ? extendedFieldsData : eventFields;
                new_extended_fields = new_extended_fields.map(field => {
                    const { defaultConstraint, ...rest } = field; 
                    return rest;
                });

                const keys = Object.keys(transaction);
                transactionObj["transaction"] = keys[0]
                if (transaction.instance !== undefined) {
                    transactionObj["instance"] = transaction.instance;
                }

                if (eventTriggerRequiredTypes.includes(selectedWidget?.type)) {

                    selectedItem.transaction = transactionObj.transaction;
                    selectedItem.instance = transactionObj.instance;
                    if(controlTypes.includes(selectedWidget?.type) && gettertransaction && gettertransaction.select === undefined) {
                        const keys = Object.keys(gettertransaction);
                        selectedItem.gettertransaction = keys[0];
                        selectedItem.getterinstance = gettertransaction.instance;
                    } else {
                        delete selectedItem.gettertransaction;
                        delete selectedItem.getterinstance;
                    }
                    if (new_extended_fields && selectedWidget.type !== 'chat') selectedItem.extendedfields = new_extended_fields;
                } else if (actionRequiredTypes.includes(selectedWidget?.type)) {
                    if (selectedItem.tableactions === undefined) {
                        selectedItem.tableactions = []
                    }

                    let tableActionObj = {
                        name: name,
                        desc: title,
                        type: "button",
                        action: 'create',
                        transaction: transactionObj.transaction,
                        title: title,
                        instance: transactionObj.instance,
                        extendedfields: new_extended_fields
                    }

                    if(gettertransaction && gettertransaction.select === undefined) {
                        const keys = Object.keys(gettertransaction);
                        tableActionObj.gettertransaction = keys[0];
                        tableActionObj.getterinstance = gettertransaction.instance;
                    }

                    if (selectedSchema === undefined) {
                        tableActionObj.id = shortUUiD.generate();
                        selectedItem.tableactions.push(tableActionObj);
                    } else {
                        tableActionObj.id = selectedSchema?.id;
                        const existingIndex = selectedWidget.tableactions.findIndex(item => item.id == selectedSchema?.id);
                        if (existingIndex !== -1) {
                            selectedItem.tableactions[existingIndex] = tableActionObj;
                        }
                    }
                }
            }
            else {
                if (selectedItem.transaction) delete selectedItem.transaction;
                if (selectedItem.instance) delete selectedItem.instance;
                if (selectedItem.extendedfields) delete selectedItem.extendedfields;
                delete selectedItem.gettertransaction;
                delete selectedItem.getterinstance;
            }

            


            if (clicktrackertransaction !== undefined && clicktrackertransaction.select === undefined) {
                const keys = Object.keys(clicktrackertransaction);
                transactionObj["clicktrackertransaction"] = keys[0]
                if (clicktrackertransaction.instance !== undefined) {
                    transactionObj["instance"] = clicktrackertransaction.instance;
                }
                selectedItem.clicktrackertransaction = transactionObj.clicktrackertransaction;
                selectedItem.clicktrackinstance = transactionObj.instance;
            }
            else {
                if (selectedItem.clicktrackertransaction) delete selectedItem.clicktrackertransaction;
                if (selectedItem.clicktrackinstance) delete selectedItem.clicktrackinstance;
            }


            dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: {id: selectedWidget.id, ...selectedItem} }));
            if (updateTableOperations && typeof updateTableOperations === "function") updateTableOperations();
            const updatedView = updateViewSchema(selectedView, 'edit', { id: selectedItem.id, updatedData: selectedItem });
            handleViewUpdate(updatedView);

        } catch (error) {
            console.error(`Updating widget failed. ${error.message}`);
            return;
        }
    }

    const handleViewUpdate = (updatedView) => {
        dispatch(invokePostService('updateView', { view: updatedView }, [selectedView._id])).then(response => {
            setIsUpdating(false);
            if (response.status === true) {
                dispatch(editView(updatedView));
                onCompletion('Widget', action === 'create' ? 'add' : 'edit');
            } else {
                if (response.code === 255) {
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    if (rightDrawerStatus === true) dispatch(toggleRightDrawer());
                }
            }
        })
    }


    const customValidation = (data) => {

        let errors = [];
        // validating 'transaction' and 'instance' in table action
        if (eventTriggerRequiredTypes.includes(selectedWidget?.type) || actionRequiredTypes.includes(selectedWidget?.type)) {
            if (formValues.transaction.select) {
                errors.push({
                    path: "operations.transaction",
                    property: 'format',
                    message: "Transaction is required",
                })
            }
        }

        return errors;
    }

    const validation = (schema, value, path) => {

        let errors = [];
        if (path === "operations.name" && value === "") {
            errors.push({
                path,
                property: 'format',
                message: "Name is required"
            })
        }

        if (path === "operations.title" && value === "") {
            errors.push({
                path,
                property: 'format',
                message: "Title is required"
            })
        }

        const whiteSpacePattern = /^[a-zA-Z0-9_]*$/;
        if (path === "operations.name" && !whiteSpacePattern.test(value)) {
            errors.push({
                path,
                property: 'format',
                message: "This field cannot contain special characters or white spaces"
            })
        }

        return errors;
    }

    useEffect(() => {
        if (editorWrapper?.current) {
            const grid1 = editorWrapper?.current?.querySelector('.MuiGrid-spacing-xs-1');
            const grid2 = editorWrapper?.current?.parentNode

            if (grid1) grid1.style.margin = 0;
            if (grid2) grid2.style.margin = 0;
        }
    }, [editorWrapper])


    return (

        <>
            {loading &&
                <Grid item xs={12}>
                    <SkeletonLoader isLabelled type="form" />
                </Grid>
            }
            {!loading && <Box ref={editorWrapper} style={{ width: '100%' }}>
                <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} onChangeJsonEditor={onChangeJsonEditor} editorId={editorId} validation={validation} />
                {!hideFieldExtensionsTable &&
                <Grid item xs={12} style={{ marginBottom: '10px', overflow: 'hidden' }}>
                    <FieldExtensionTable onLoadData={eventFields || []} setExtendedFieldsData={setExtendedFieldsData} />
                </Grid>}
            </Box>}
            <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginTop: '30vh' } : { display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel updateDisable={isUpdating || loading} forceCancel={forceCancel} noFloatButton={noFloatButton} content={isUpdating ? "Updating.." : "Update"} onUpdate={onUpdate} onCancel={onClose} />
            </Grid>
        </>

    )

}